import { isNullOrUndefined } from '@deltasierra/type-utilities';
import { getMoment, utcToLocalDate } from '../common';
const moment = getMoment();

export function getDefaultScheduledTime(
    minimumMinutesAhead: number,
    plannerDetails: { date: Date } | null | undefined,
    plannerDateHour: number,
): any {
    let scheduledTime;
    if (isNullOrUndefined(plannerDetails)) {
        scheduledTime = moment().add(minimumMinutesAhead, 'minutes').toDate();
    } else {
        scheduledTime = utcToLocalDate(plannerDetails.date, plannerDateHour);
    }
    return scheduledTime;
}
